<template>
  <div class="qfe">
    <div v-for="(f, i) in rows" :key="i" class="qfe__row">
      <el-select
        v-model="f.key"
        placeholder="key"
        size="small"
        allow-create
        filterable
        class="qfe__key"
        @change="emit"
      >
        <el-option v-for="k in filterKeys" :key="k" :label="k" :value="k" />
      </el-select>
      <el-input v-model="f.value" placeholder="value" size="small" class="qfe__value" @input="emit" />
      <el-input v-model="f.action" placeholder="action" size="small" class="qfe__action" @input="emit" />
      <el-button size="mini" type="danger" icon="el-icon-delete" @click="remove(i)" />
    </div>
    <el-button size="mini" plain icon="el-icon-plus" @click="add">Add filter</el-button>
  </div>
</template>

<script>
const FILTER_KEYS = ["illnesses.id", "illnesses.kind", "operations.id", "diagnostics.id", "tag"];

export default {
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      filterKeys: FILTER_KEYS,
      rows: this.normalize(this.value),
    };
  },
  watch: {
    value(v) {
      this.rows = this.normalize(v);
    },
  },
  methods: {
    normalize(v) {
      return (v || []).map((f) => ({ key: f.key || "", value: f.value || "", action: f.action || "" }));
    },
    add() {
      this.rows.push({ key: "", value: "", action: "" });
      this.emit();
    },
    remove(i) {
      this.rows.splice(i, 1);
      this.emit();
    },
    emit() {
      this.$emit("input", this.rows.map((f) => ({ ...f })));
    },
  },
};
</script>

<style scoped>
.qfe__row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.qfe__key {
  width: 170px;
}
.qfe__value {
  width: 200px;
}
.qfe__action {
  width: 130px;
}
</style>
